/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Select_The_Layout_Engine_ThatInputs */

const en_select_the_layout_engine_that = /** @type {(inputs: Select_The_Layout_Engine_ThatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select the layout engine that powers your storefront experience.`)
};

const es_select_the_layout_engine_that = /** @type {(inputs: Select_The_Layout_Engine_ThatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecciona el motor de diseño que impulsa la experiencia de tu tienda.`)
};

const fr_select_the_layout_engine_that = /** @type {(inputs: Select_The_Layout_Engine_ThatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionnez le moteur de mise en page qui propulse l'expérience de votre vitrine.`)
};

const de_select_the_layout_engine_that = /** @type {(inputs: Select_The_Layout_Engine_ThatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wähle die Layout-Engine, die das Erlebnis deiner Storefront antreibt.`)
};

const ja_select_the_layout_engine_that = /** @type {(inputs: Select_The_Layout_Engine_ThatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ストアフロントの体験を駆動するレイアウトエンジンを選択します。`)
};

const zh_select_the_layout_engine_that = /** @type {(inputs: Select_The_Layout_Engine_ThatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择驱动您店铺体验的布局引擎。`)
};

const ar_select_the_layout_engine_that = /** @type {(inputs: Select_The_Layout_Engine_ThatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حدد محرك التخطيط الذي يشغل تجربة واجهة متجرك.`)
};

const id_select_the_layout_engine_that = /** @type {(inputs: Select_The_Layout_Engine_ThatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih mesin tata letak yang mendayagunakan pengalaman etalase Anda.`)
};

const it_select_the_layout_engine_that = /** @type {(inputs: Select_The_Layout_Engine_ThatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona il motore di layout che guida l'esperienza della tua vetrina.`)
};

const ru_select_the_layout_engine_that = /** @type {(inputs: Select_The_Layout_Engine_ThatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите движок макета для вашей витрины.`)
};

const pt_select_the_layout_engine_that = /** @type {(inputs: Select_The_Layout_Engine_ThatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione o mecanismo de layout que impulsiona a experiência da sua vitrine.`)
};

const ko_select_the_layout_engine_that = /** @type {(inputs: Select_The_Layout_Engine_ThatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`스토어프론트 경험을 구동할 레이아웃 엔진을 선택하세요.`)
};

/**
* | output |
* | --- |
* | "Select the layout engine that powers your storefront experience." |
*
* @param {Select_The_Layout_Engine_ThatInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const select_the_layout_engine_that = /** @type {((inputs?: Select_The_Layout_Engine_ThatInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Select_The_Layout_Engine_ThatInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_select_the_layout_engine_that(inputs)
	if (locale === "es") return es_select_the_layout_engine_that(inputs)
	if (locale === "fr") return fr_select_the_layout_engine_that(inputs)
	if (locale === "de") return de_select_the_layout_engine_that(inputs)
	if (locale === "ja") return ja_select_the_layout_engine_that(inputs)
	if (locale === "zh") return zh_select_the_layout_engine_that(inputs)
	if (locale === "ar") return ar_select_the_layout_engine_that(inputs)
	if (locale === "id") return id_select_the_layout_engine_that(inputs)
	if (locale === "it") return it_select_the_layout_engine_that(inputs)
	if (locale === "ru") return ru_select_the_layout_engine_that(inputs)
	if (locale === "pt") return pt_select_the_layout_engine_that(inputs)
	return ko_select_the_layout_engine_that(inputs)
});